import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as value from '../../../../value'
import * as models from '../../../models'

import * as booleanValue from './boolean'
import * as listValue from './list'
import * as numberValue from './number'

@ngCore.Component({
  imports: [
    value.Component,
    booleanValue.Component,
    listValue.Component,
    numberValue.Component,
  ],
  selector: 'atn-ds-table-cell-renderer',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link models.config.Cell}  */
  // NOTE: public only for ngCore.input purposes
  public readonly _cellSg = ngCore.input.required<
    models.config.Cell.Applied<ec.models.TypeParams.Constraint.Default>
  >({
    alias: 'cellConfig',
  })

  /** @see {@link models.config.Cell.Context.value} */
  public readonly valueSg = ngCore.computed(
    (cell = this._cellSg()) => cell.value,
  )

  /** @see {@link ents.core.common.Attribute} */
  private readonly _attribute = ngCore.computed(
    (cell = this._cellSg()) => cell.attribute,
  )

  /** @see {@link ents.core.common.value.Info} */
  public readonly valueInfoSg = ngCore.computed(
    (attribute = this._attribute()) => attribute.valueInfo,
  )

  /**
   * Returns expected value type from {@link valueInfoSg} if defined, otherwise infers type from {@link valueSg}
   *
   * @see {@link ents.core.dms.data.Value.Type}
   */
  public readonly typeSg = ngCore.computed(
    (valueInfo = this.valueInfoSg(), val = this.valueSg()) =>
      valueInfo?.type ?? ents.core.common.value.types.Intrinsic.inferFrom(val),
  )

  /** Value cast to list */
  public readonly listValueSg = ngCore.computed(
    (_value = this.valueSg(), type = this.typeSg()) => {
      const intrinsic = ents.core.common.value.types.Intrinsic.from(type)

      return intrinsic === ents.core.common.value.types.Intrinsic.List
        ? ents.core.common.value.Raw.cast(_value, intrinsic)
        : undefined
    },
  )

  /** Value cast to raw */
  public readonly rawValueSg = ngCore.computed(
    (_value = this.valueSg(), type = this.typeSg()) =>
      type ? ents.core.common.value.Raw.cast(_value, type) : undefined,
  )

  /** @see {@link ents.core.common.value.types.Intrinsic} */
  public readonly IntrinsicEnum = ents.core.common.value.types.Intrinsic
}
